import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVesselDishedBottomSurfaceIndication = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 87.69,
	viewBox: "0 0 40.0 87.69",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 40.0 0.0 L 40.0 80.0 A 13.0 5.0 0.0 0 1 0.0 80.0 L 0.0 0.0 L 40.0 0.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 40.0 10.0 M 0.0 80.0 L 40.0 80.0 M 20.0 5.0 L 10.0 5.0 L 13.0 9.0 L 16.0 5.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgVesselDishedBottomSurfaceIndication;
